import { useQuery } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";

import {
  ANALYTICS_QUERY_KEY,
  toAnalyticsQuery,
  type AnalyticsFilters,
} from "./useSummary";

export function useDayOfWeekBreakdown(filters: AnalyticsFilters = {}) {
  const client = useApiClient();
  return useQuery({
    queryKey: [...ANALYTICS_QUERY_KEY, "day-of-week-breakdown", filters],
    queryFn: async () => {
      const { data, error } = await client.GET(
        "/api/analytics/day-of-week-breakdown",
        { params: { query: toAnalyticsQuery(filters) } },
      );
      if (error !== undefined) {
        throw new Error("Failed to load day-of-week breakdown");
      }
      return data;
    },
  });
}
